<div class="modal-header">
    <h4 class="modal-title">{{ dialogHeader }}</h4>
</div>
<div class="modal-body" (keyup.esc)="cancel()" (keyup.enter)="enterPressed()">
    <div class="mb-2" *ngIf="dialogPrompt">{{ dialogPrompt }}</div>
    <div *ngIf="mode === 'text'">
        <dx-text-box #inputComponent [(value)]="dialogValue"> </dx-text-box>
    </div>
    <div *ngIf="mode === 'number'">
        <dx-number-box #inputComponent [(value)]="dialogValue"> </dx-number-box>
    </div>
    <div *ngIf="mode === 'password'">
        <dx-text-box #inputComponent [(value)]="dialogValue" [mode]="'password'"> </dx-text-box>
    </div>
    <div *ngIf="mode === 'textarea'">
        <dx-text-area #inputComponent [(value)]="dialogValue" [height]="300"> </dx-text-area>
    </div>
    <div *ngIf="mode === 'select'">
        <dx-select-box #inputComponent [(value)]="dialogValue" [items]="dialogValueArray"></dx-select-box>
    </div>
    <div *ngIf="mode === 'selectWithId'">
        <dx-select-box #inputComponent [(value)]="dialogValue" [items]="dialogValueArray" [valueExpr]="'id'" [displayExpr]="'name'"></dx-select-box>
    </div>
    <div *ngIf="mode === 'selectWithOther'">
        <dx-select-box #inputComponent [(value)]="dialogValue" [items]="dialogValueArray"></dx-select-box>
        <dx-text-box *ngIf="dialogValue === 'Other'" class="mt-2" [(value)]="otherValue" placeholder="Enter reason"></dx-text-box>
    </div>
    <div *ngIf="mode === 'tagBox'">
        <dx-tag-box
            #inputComponent
            [(value)]="dialogValue"
            [items]="dialogValueArray"
            [valueExpr]="'id'"
            [displayExpr]="'name'"
            [showSelectionControls]="true"
            [showDropDownButton]="true"
        ></dx-tag-box>
    </div>
    <div *ngIf="mode === 'color'">
        <dx-color-box #inputComponent [(value)]="dialogValue" [editAlphaChannel]="true"></dx-color-box>
    </div>
    <div *ngIf="mode === 'date'">
        <dx-date-box #inputComponent [(value)]="dialogValue"></dx-date-box>
    </div>
    <div class="mt-3" *ngIf="!!dialogMessage">
        {{ dialogMessage }}
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="save(true)" [hidden]="!saveAndNewVisible">Save & New</button>
    <button type="button" class="btn btn-success" (click)="save()" [disabled]="processing">Save</button>
    <button type="button" class="btn btn-light" (click)="cancel()">Cancel</button>
</div>
